// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DvZM","delete":"styles_delete__3dj7v","update":"styles_update__2qmFT","add":"styles_add__3g1d4"};